<label for="" class="form-label" *ngIf="!!title">{{ title }}
    <span *ngIf="isRequired" class="astrix-red">*</span>
</label>
<ng-content select="app-radio-box"></ng-content>